module.exports = __webpack_public_path__ + "static/media/TeamsAssets-Light.03c2e862.eot";